import { createSelector } from 'reselect';

import { getEnclaves, getEnclaveList } from '../enclave/getters';
import { IndexableObjectType } from 'shared/types/common';
import { RootState } from '../../index';

export const getSourceEnclaves = createSelector(
  getEnclaveList,
  (enclaves) => enclaves.filter((enclave) => enclave.workflowSupported),
);

const preFormattedSourceMappings = (state: RootState) => state.source.sourceMappings;

/**
 * Source map endpoint currently returns a map of {sourceKey: [relevent guids]}, we want to look up source keys by guid so we are flipping the map
 */
export const getSourceMapper = createSelector(
  preFormattedSourceMappings,
  (sourceMapObject) => {

    const IdToSourceKeyMap = Object.entries(sourceMapObject).reduce((finalResult: IndexableObjectType, currentEntry: [string, any]) => {

      const [sourceKey, source_guids] = currentEntry;
      source_guids.forEach((guid: string | number) => {
        finalResult[guid] = sourceKey;
      })
      return finalResult;
    }, {});
    
    return IdToSourceKeyMap;
  }
);

export const getSourceToView = createSelector(
  getEnclaves,
  (enclaves) => enclaves.source.sourceToView,
);
